<template>
  <div class="sending-order">
    <div class="dialog-content">
      {{ textInfo }}
      <bouncing-spinner class="spinner"></bouncing-spinner>
    </div>
  </div>
</template>
<script></script>

<script>
export default {
  props: ['text'],
  computed: {
    textInfo() {
      return this.text ? this.text : 'Uw opdracht wordt verwerkt.'
    }
  }
}
</script>

<style lang="scss" scoped>
.sending-order {
  text-align: center;
}

.spinner {
  margin-top: 18px;
}
</style>
